import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  padding: 24px;
  line-height: 1.6;
`;

const Italic = styled.i``;

const Bold = styled.b``;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  width: 60%;
`;

const Image = styled.img`
  width: 30%;

  @media (max-width: 1000px) {
    width: 75%;
  }

  @media (max-width: 768px) {
    width: 75%;
  }
`;

const ConceptualArt = () => {
  return (
    <Wrapper>
      <Row>
        <Image
          src="/images/g/Naslovna foto konceptualna_2.jpg"
          alt="citajte o - konceptualna umetnost"
        />
      </Row>
      <b>Hronologija konceptualne umetnosti u Jugoslaviji*</b>
      <br />
      <br />
      <Bold>1966.</Bold>
      <br />
      -Mart-april: RADOMIR DAMNJANOVIĆ – DAMNJAN. Samostalna izložba u Galeriji
      Doma omladine u Beogradu.
      <br />
      -April: IVAN KOŽARIĆ. Samostalna izložba u Galeriji Doma omladine u
      Beogradu.
      <br />
      -April-maj: RADOMIR DAMNJANOVIĆ – DAMNJAN. Samostalna izložba slika u
      Galeriji suvremene umjetnosti u Zagrebu.
      <br />
      -Leto: Ljubljana. GRUPA OHO. Početak aktivnosti grupe. Prvi članovi: Marko
      Pogačnik, Iztok Geister Plamen, Milenko Matanović, Franci Zagoričnik,
      Matjaž Hanžek, Vojin Kovač-Chibby i Naško Križnar.
      <br />
      -Zagreb. GORGONA. Izlazi poslednji broj časopisa Gorgona, grupa prestaje
      da deluje.
      <br />
      <br />
      <Bold>1967.</Bold>
      <br />
      -Mart: Galerija Kulturnog centra. Beograd, IZLOŽBA KRITIKE. Kritičari: Đ.
      Kadijević, M. Kalezić, P. Vasić. Prva smotra likovnih umentika koje su
      kritičari odabrali kao najuspešnije u protekloj godini u Beogradu. Đ.
      Kadijević: R. Damnjanović, D. Otašević, R. Reljić.
      <br />
      -April: Podrum, Ilica 12, Zagreb. NAŠ HAPP. Prvi hepening Tomislava
      Gotovca (sa Lukasom Šercarom i Ivicom Gorijupom).
      <br />
      -Septembar: Atelje 212, Beograd. BITEF. LIVING TEATAR U BEOGRADU. Tekst iz
      kataloga Bitefa: „…Posle višegodišnjeg razmišljanja beogradsko avangardno
      pozorište Atelje 212 ostvariće prvi put beogradski internacionalni
      teatarski festival od 8. do 30. septembra 1967. godine. Festival je
      zamišljen kao smotra novih pozorišnih tendencija pod koju želi da podvede
      sve učesnike festivala, ali je sigurno da nove pozorišne tendencije nisu
      jučerašnja avangarda, već pozorište budućnosti.”
      <br />
      <br />
      <Bold>1968.</Bold>
      <br />
      -Januar-februar: Galerija Doma omladine, Beograd. VLADAN RADOVANOVIĆ.
      Samostalna izložba nazvana Prozirne slike, crteži i elektronska muzika.
      Tekst u katalogu: Ljubomir Gligorijević.
      <br />
      -April-maj: Atelje 212. Beograd. Otvorena Galerija 212. Članovi saveta: B.
      Tomić, I. Subotić, D. Blažević, J. Denegri, D. Kalajić, S. Mašić, R.
      Reljić. Prva izložba Slikarstvo surovosti; izlagači: G. Ailland, A.
      Arroyo, R. Canogar, R. Damnjanović, E. Feller, D. Kalajić, D. Otašević, R.
      Reljić, A. Segui, L. Šejka.
      <br />
      -Septembar: Galerija 212. Beograd. MANIFESTACIJE U SASTAVU II BBITEF-A.
      <ul style={{ paddingLeft: "40px", margin: 0, listStyleType: "disc" }}>
        <li>
          Prva izložba grupe OHO u Beogradu; grupa izvela hepening Pasija
          (starozavetne scene).
        </li>
        <li>Međunarodna izložba Arte Permanente.</li>
        <li>
          Eksperimentalni filmovi: Piero Bargellini, Franco Vaccari, Maurizio
          Nannucci.
        </li>
        <li>
          Boris Kelemen, „Kompjuteri i vizuelna istraživanja” (predavanje)
        </li>
        <li>Novak Koloman, izložba.</li>
      </ul>
      -Novembar-decembar: Galerija Studentskog centra Zagreb. BRACO
      DIMITRIJEVIĆ. Samostalna izložba Suma 680 na kojoj publika učestvuje u
      stvaranju ludičkog ambijenta sastavljenog od 680 raznobojnih konzervi.
      -Decembar: Galerija 212. Beograd. GLAVA. Tematska izložba. Koncepcija: Lj.
      Gligorijević i M. Čolović; izlagači: B. Bem, K. Bogdanović, B. Iljovski,
      D. Otašević, P. Pašćan, Z. Popović, D. Lubarda, S. Knežević, I. Tabaković,
      V. Veličković, M. Vuković.
      <br />
      <br />
      <Bold>1969.</Bold>
      <br />
      -Januar: ROK. Beograd. Direkcija: Bora Ćosić, Mića Danojlić, Vladan
      Radovanović. Design: Slobodan Mašić. Prvi broj časopisa za književnost,
      umetnost i estetsko ispitivanje stvarnosti. „Rok” je objavio prvi
      kompletni pregled grupe OHO.
      <br />
      -Februar: Galerija suvremene umjetnosti, Zagreb. GRUPA OHO. Pradedovi,
      prva izložba arte povere u Jugoslaviji.
      <br />
      -Avgust: Subotica. 27. avgusta 1969. osnovana grupa Bosch + Bosch.
      Osnivač: Slavko Matković. Članovi: Edit Basch, Istvan Krekovics, Zoltan
      Magyar, Laszlo Szalma, Balint Szombathy i Slobodan Tomanović.
      <br />
      -Avgust-septembar: Beograd. ZORAN POPOVIĆ. Realizacija filma Glava/krug.
      <br />
      -Septembar: Galerija 212. Beograd. MANIFESTACIJE U SASTAVU III BITEF-A.
      Izložbe:
      <ul style={{ paddingLeft: "40px", margin: 0, listStyleType: "disc" }}>
        <li>
          Gde je njima mesto, odbijeni članovi Oktobarskog salona; izlagači: K.
          Bogdanović, T. Kauzlarić, D. Otašević, N. Prvulović, S. Radojčić, M.
          Tripković.
        </li>
        <li>
          Zveri iza i ispred žice, izlagači: K. Bogdanović, M. Čolović, E.
          Dragulj, Ž. Đak, S. Knežević, D. Otašević, S. Radojčić, V. Veličković,
          B. Bem.
        </li>
        <li>Grupa OHO, Urbani teatar na ulicama Beograda.</li>
        <li>Vreme u našim očima, fotografije: P. Brent i P. Dabac.</li>
      </ul>
      -Novembar: Tribina mladih, Novi Sad, GRUPA OHO. Pradedovi. Prva izložba
      OHO-a u Novom Sadu.
      <br />
      -Decembar: Dom omladine, Beograd. GRUPA OHO. Tekst u katalogu izložbe:
      Ješa Denegri.
      <br />
      <br />
      <Bold>1970.</Bold>
      <br />
      -Januar: Galerija Kolarčevog narodnog univerziteta, Beograd. Prva
      kolektivna izložba slika i grafika: R. Todosijević, N.Paripović, Z.
      Popović,G. Urkom, A. Jovanović, M. Điković.
      <br />
      -Februar: Tribina mladih, Novi Sad. RADOMIR DAMNJANOVIĆ-DAMNJAN.
      Samostalna izložba slika. Na otvaranju izložbe Bora Ćosić čitao fragmente
      iz svog romana „Uloga moje porodice u svetskoj revoluciji”.
      <br />
      -April: Tribina mladih, Novi Sad. GRUPA KOD. 8. aprila osnovana grupa KOD.
      Prvi članovi: Branko Andrić, Slavko Bogdanović, Janez Kocijančić, Mirko
      Radojićić, Miroslav Mandić, Slobodan Tišma; 9. aprila grupa je izvela prvi
      javni nastup Prostorne interakcije.
      <br />
      -April: Beograd. Ekipa za akciju i anonimnu apstrakciju osnovana je aprila
      1970. u Beogradu. Prvi članovi: Dobrivoje Petrović, Jugoslav Vlahović,
      Mladen Jevđović, Rista Banić, Dubravko Kalenić, Nenad Petrović. Prva
      akcija Merenje.
      <br />
      -Maj: MIXED MEDIA. Bora Ćosić, nezavisno izdanje. Beograd. Oprema: Branko
      Vučićević.
      <br />
      -Maj: Tribina mladih, Novi Sad. GRUPA KOD izvela akciju Zglob – sedam
      vizuelnoakustičkih akcija (Platno, Kocka, Asugenili, Muška i ženska
      planina, Krik, Ogledalo koje volim, Motorna pila).
      <br />
      -Proleće: Tribina mladih, Novi Sad. Tomislav Gotovac. Autorsko veče,
      projekcija filma Kuda idemo ne pitajte.
      <br />
      -Jul: Mladost Sutjeske ’70, Tjentište. GRUPA KOD. Izložba/akcija grupe
      KOD: Projekti pesme, Kaskade, Apoteoza Džeksonu Poloku, Polikolorna
      interakcija...
      <br />
      -Jul-septembar: Muzej savremene umetnosti, Beograd. IV BEOGRADSKI
      TRIJENALE JUGOSLOVENSKE LIKOVNE UMETNOSTI. Izložba IV Trijenala prikazala
      je umetničke pojave u jugoslovenskoj umetnosti od 1967. do 1970.
      Koncepciju je odredio Organizacioni odbor sastavljen od osamnaestorice
      umetnika i likovnih kritičara iz svih jugoslovenskih centara. Sekcije:
      Slikari kontinuiteta, Vidovi savremene figuracije, Vidovi savremene
      apstrakcije, Objekti, Kompjuteri i vizuelna istraživanja, Konceptualna i
      siromašna umetnost, Vizuelna poezija, Grafika, Skulptura i Tapiserija. (…)
      Među izlagačima: Grupa OHO, V. Radovanović, Damnjan, Boris Bućan...
      <br />
      -Septembar: Tribina mladih, Novi Sad. BOGDANKA POZNANOVIĆ. Akcija
      Srce-predmet.
      <br />
      -Septembar: Galerija 212. MANIFESTACIJE U SASTAVU IV BITEF-A.
      <br />
      <ul style={{ paddingLeft: "40px", margin: 0, listStyleType: "disc" }}>
        <li>
          Michelangelo Pistoleto sa grupom LO ZOO izveo dve predstave –
          Dresirani čovek, u Skadarliji, Ko si ti? u Domu omladine.
        </li>
        <li>
          Germano Celant, predavanje uz dijaprojekcije o izložbi Conceptual art
          – Arte povera – Land Art.
        </li>
        <li> Grupa OHO, Fiksiranje tačke u kolektivnoj memoriji</li>
        <li>Goran Trbuljak, Ulične akcije-obcrtavanje</li>
        <li> Braco Dimitrijević, Projekt Ali-baba i Misaone koordinacije</li>
        <li>Jagoda Kaloper, Sigurnosne šibice</li>
        <li>Želimir Koščević, objava Akcije Total</li>
        <li> Ekipa A³, Poljska izložba</li>
      </ul>
      -Decembar: Tribina mladih, Novi Sad. BOSCH+BOSCH. Prva samostalna izložba
      grupa (u Novom Sadu).
      <br />
      -Decembar: Galerija Doma omladine, Beograd. NEŠA PARIPOVIĆ. ZVONIMIR
      MARKOVIĆ. Samostalna izložba slika.
      <br />
      -Časopis POLJA, Novi Sad. Br. 140, 141/42, 143. Informacije o vizuelnim
      umetnostima, priredila Bogdanka Poznanović
      <br />
      <br />
      <Bold>1971.</Bold>
      <br />
      -Januar: Dom sindikata, Beograd. FEST. U okviru FEST-a članovi grupe KOD
      izveli tri akcije.
      <br />
      -Januar-febaruar 1971. Muzej savremene umetnosti, Beograd. MLADI 70. Prva
      izložba mladih umetnika u Muzeju. Koncepcija: Ješa Denegri i Dragoslav
      Đorđević. Izlagači: M. Abramović, Lj. Blažeska, D. Dobrić, M. Điković, P.
      Đorđević, B. Iljovski, S. Ivanković, I. Kostov, D. Lučić, Z. Marković, B.
      Milićević, N. Paripović, Z. Nikolić, Z. Popović, M. Radović, R.
      Todosijević, G. Urkom.
      <br />
      -Februar: Dom omladine, Beograd. KOKTEL NOVE UMETNOSTI. Na izložbi/akciji
      Koktel nove umetnosti učestvovali članovi grupe KOD i buduće grupe (Ǝ.
      <br />
      -Februar: Novi Sad. Osnovana grupa (Ǝ. Članovi: Vladimir Kopicl, Čedomir
      Drča, Ana Raković, Miša Živanović.
      <br />
      -Mart: Galerija Kulturnog centra, Beograd. KRITIČARI SU IZABRALI 70.
      Kritičari: Pavle Vasić, Marija Pušić, Siniša Vuković, Ješa Denegri i Sreto
      Bošnjak. Ješa Denegri: R. Damnjanović, V. Mihić, Z. Radović.
      <br />
      -Mart: Salon Muzeja savremene umetnosti, Beograd. PRIMERI KONCEPTUALNE
      UMETNOSTI U JUGOSLAVIJI. Koncepcija: B. Tomić i J. Denegri. Izlagači:
      grupa OHO, grupa KOD, grupa (Ǝ, G. Trbuljak, B. Dimitrijević, Nuša i Srečo
      Dragan.
      <br />
      -April: Studentski kulturni centar, Beograd. Na Dan studenata, 4. aprila,
      otvoren je Studentski kulturni centar.
      <br />
      -April: Haustor u Frankopanskoj 2a. AT THE MOMENT. Prva međunardona
      izložba konceptualne umetnosti u Jugoslaviji. Koncepcija: Nena i Braco
      Dimitrijević. Izlagači: G. Anselmo, R. Barry, S. Brouwn, D. Buren, V.
      Burgin, J. Dibbets, B. Dimitrijević, ER Group, B. Flanagan, D. Houbler,
      Grupa OHO, Grupa KOD, A. Kirili, J. Kounellis, J. Latham, S. LeWitt, G.
      Trbuljak...
      <br />
      -April: Tribina mladih, Novi Sad. GORAN TRBULJAK. Izložba Filmovi
      snimljeni na 35mm.
      <br />
      -Maj: FILMFORUM – novosnovani časopis za alternativni film i srodne
      medije.
      <br />
      -Jun: Galerija Studentskog kulturnog centra, Beograd. DRANGULARIJUM.
      Izlagači: M. Nešić, Dušan Otašević, Halil Tikveša, Radomir Reljić, Raša
      Todosijević, Radomir Damnjanović Damnjan, Stevan Knežević, Bojan Bem,
      Slobodan Era Milivojević, Bora Iljovski, J. Alebić, Gergelj Urkom, Neša
      Paripović, Marina Abramović, Zoran Popović, Evgenija Demnievska.
      <br />
      -Jun: Novi Sad. Formirana grupa (Ǝ KOD. Članovi: Č. Drča, V. Kopicl, M.
      Radojičić, A. Ćaković, P. Vranešević.
      <br />
      -Jul: Galerija T-70, Grižnjan. Intervencije u prostoru: Raša Todosijević,
      Gergelj Urkom, Zoran Popović, Neša Paripović, Marina Abramović, Bojan
      Bem...
      <br />
      -Septembar: Galerija 212 i Studentski kulturni centar, Beograd.
      MANIFESTACIJE U SASTAVU V BITEF-A.
      <ul style={{ paddingLeft: "40px", margin: 0, listStyleType: "disc" }}>
        <li>
          Izložba Persona, koncepcija Achille Bonito Oliva; izlagači: A. Boetti,
          P. Calzolari, L. Fabro, M. Germana, J. Kounellis, M. Merz, G. Paolini…
          Povodom izložbe održan razgovor sa A. B. Olivom, J. Kounelliusom, M.
          Germanom.
        </li>
        <li>
          Predavanje: Tommaso Trini, urednik DATE, Gian Carlo Goliti, urednik
          FLASH ART-a, Pio Monti, Lucio Amelio.
        </li>
        <li>
          Izložba Objekti i projekti: M. Abramović, Z. Popović, G. Urkom, R.
          Todosijević, S. Milivojević.
        </li>
        <li>
          Izložba In the Another Moment (izložbi At The Moment priključeni
          radovi Josepha Bouysa). Galerija Studentskog kulturnog centra štampala
          katalog; tekst u katalogu: Nena Dimitrijević.
        </li>
      </ul>
      -Septembar: Galerija Studentskog kulturnog centra, Beograd. CATHERINE
      MILLET. Održala predavanje o konceptualnoj umetnosti.
      <br />
      -Septembar-oktobar: VII BBIENNALE DE JEUNES, Pariz. Komesar jugoslovenske
      sekcije J. Denegri. Izlagači: Grupa OHO, grupe KOD i (Ǝ, G. Trbuljak, B.
      Dimitrijević, D. Martinis. S. Iveković, B. Bućan, G. Žuvela.
      <br />
      -Oktobar: Galerija Studentskog kulturnog centra, Beograd. OKTOBAR 71.
      Izložba i akcije umetnika: R. Todosijević, Z. Popović, G. Urkom, M.
      Abramović, S. Milivojević, N. Paripović.
      <br />
      -Novembar: Ludoško jezero kod Subotice. BOSCH+BOSCH. S. Matković:
      Intervencije u slobodnom prostoru.
      <br />
      -Novembar: Obala Dunava, Novi Sad. BOGDANKA POZNANOVIĆ. Akcija Kocke/reke.
      <br />
      -Decembar: Tribina mladih, Novi Sad. BOGDANKA POZNANOVIĆ. Izložba
      instalacija Self-service (konzumiranje komplementara).
      <br />
      <br />
      <Bold>1972.</Bold>
      <br />
      -Januar: Galerija Studentskog kulturnog centra, Beograd. POŠTANSKE
      POŠILJKE i KONCEPTUALNA UMETNOST (sa VII Bijenala mladih u Parizu)
      <br />
      -Januar-februar: Muzej savremene umetnosti, Beograd. MLADI KRITIČARI I
      MLADI UMETNICI. Koncepcija: J. Tijardović, J. Vinterhalter, N. Vizner, S.
      Timotijević; izlagači: M. Abramović, M. Antić, G. Urkom, R. Hiršl, V.
      Jovanović, B. Mijušković, B. Milenković, S. Milivojević, N. paripović, Z.
      Popović, R. Todosijević, grupe: BOSCH+BOSCH, Ekipa A³, (Ǝ KOD.
      <br />
      -Februar: Galerija Studentskog kulturnog centra, Beograd. DAVID NEZ.
      Samostalna izložba Diploma.
      <br />
      -Februar: POLJA. Članovi grupe (Ǝ KOD tematski broj o Konceptualnoj
      umetnosti. Prevedeni tekstovi: J. Kosutha, grupe Art&Language, C. Millet,
      S. LeWitta… (Broj uredio M. Radojičić).
      <br />
      -Mart: Galerija Doma omladine, Beograd. ANDRAŽ ŠALAMUN. Samostalna
      izložba. -Mart: Galerija Kulturnog centra, Beograd. KRITIČARI SU IZABRALI
      71. Kritičari: Pavle Vasić, Zoran Markuš, Kosta Vasiljković, Siniša
      Vuković i Ješa Denegri. Među izlagačima: Slobodan Era Milivojević,
      Dragoljub Raša Todosijević, Zoran Popović.
      <br />
      -Mart: Galerija Studentskog kulturnog centra, Beograd. SLOBODAN ERA
      MILIVOJEVIĆ. Prva samostalna izložba Dezen.
      <br />
      -Mart-april: Tribina mladih, Novi Sad. BALINT SZOMBATHY. Prva samostalna
      izložba Nontextualite.
      <br />
      -Mart-april: Tribina mladih, Novi Sad. NUŠA I SREČO DRAGAN. Samostalna
      izložba/projekt Slušno-govorne komunikacije slogova.
      <br />
      -April: Studentski kulturni centar, Beograd. APRILSKI SUSRETI. Povodom
      Dana studenata (do 4. do 11. aprila) održan je I Aprilski susret –
      manifestacija svih programa Studentskog kulturnog centra. Susret je
      obuhvatao realizaciju odabranih radova sa Jugoslovenskog konkursa iz
      oblasti proširenih medija i programa (po pozivu) jugoslovenskih i
      inostranih medija. Povodom susreta održan je razgovor o proširenim
      medijima.
      <br />
      -Maj: EKIPA A³. Akcija Autobus na ulicama Beograda. Učesnici: D. Petrović,
      J. Vlahović, M. Jevđović, S. Timotijević, R. Banić.
      <br />
      -Septembar: Galerija Studentskog kulturnog centra, Beograd. RAŠA
      TODOSIJEVIĆ. Samostalna izložba projekata, grafika i akcija DA.
      <br />
      -Septembar: Studentski kulturni centar, Beograd. 13. septembra otvorena
      prodajna galerija poznatija kao Mala galerija ili Srećna nova umetnost.
      Ova galerija je prva u Jugoslaviji počela sa prodajom delâ nove umetnosti
      70-ih godina. Deluje i kao izdavač mapa grafika, plakata, umetničkih
      razglednica, publikacija.
      <br />
      -Septembar: Galerija 212. Beograd. MANIFESTACIJE U SASTAVU VI BITEFA.
      <br />
      <ul style={{ paddingLeft: "40px", margin: 0, listStyleType: "disc" }}>
        <li>
          Izložba: Aspekti 72. Izlagači: J. Beuys, J. Baldessari, Christo Ben,
          J. Dibbets, D. Buren, G. Trbuljak, B. Dimitrijević.
        </li>
        <li>
          D. Buren, projekt u Domu omladine; G. Chiari, koncert gestualne muzike
          (U Teatru u podrumu)
        </li>
        <li>
          Zoran Popović, Aksiomi; S. Milivojević, Med; Nuša i Srečo Dragan,
          filmovi i projekti; Ekipa A³, Apsolutni hepening u Knez Mihailovoj
          ulici.
        </li>
      </ul>
      -Oktobar: Galerija Studentskog kulturnog centra, Beograd. OKTOBAR 72.
      izložba objekata i akcija: M. Abramović, S. Milivojević, N. Paripović, Z.
      Popović, R. Todosijević, G. Urkom.
      <br />
      -Novembar: Galerija Studentskog kulturnog centra, Beograd. Ekipa A³.
      Performans Crni reflektor.
      <br />
      -Keln. Klaus Groh: AKTUELLE KUNST IN OSTEUROPA, Verlag M. Dumont,
      Schauberg, Köln. U knjizi Aktuelna umetnost u istočnoj Evropi, autorske
      stanice: Grupa OHO, grupa (Ǝ KOD, B. Dimitrijević, G. Trbuljak, N. i S.
      Dragan, B. Poznanović, M. Todorović, J. Kocijančić.
      <br />
      <br />
      <Bold>1973.</Bold>
      <br />
      -Februar: Galerija savremene umetnosti, Niš. MATERIJALI 73. Objekti i
      akcije: M. Abramović, Z. Popović, G. Urkom, S. Milivojević, R.
      Todosijević.
      <br />
      -April: Galerija suvremene umjetnosti, Zagreb. RASPONI 73. Srpska umetnost
      1969-1973. Koncepcija: J. Denegri, B. Tomić. Povodom izložbe izvedeni
      performansi/akcije.
      <br />
      -April: Studentski kulturni centar, Beograd. II APRILSKI SUSRET. II
      Aprilski susret na temu Proširenih medija okupio je ponovo mnoge umetnike
      iz Jugoslavije i inostranstva. Povodom susreta održan je razgovor o
      proširenim medijima na kome su učestovali Aleksa Čelebonović, Vladan
      Radovanović, Kosta Bogdanović, Jovan Ćirilov, M. Marinović, B. Zečević,
      Ješa Denegri, Nikola Vizner.
      <br />
      -Jun: Galerija Studentskog centra, Zagreb. XEROX. Međunarodna izložba
      xerox radova.
      <br />
      -Jun: Galerija Studentskog kulturnog centra, Beograd. ZORAN POPOVIĆ.
      Samostalna izložba fotografija Postavka o pre-ideji.
      <br />
      -Jun-jul: Galerija suvremene umjetnosti, Zagreb. TENDENCIJE 5. U okviru
      Tendencija 5 sekcija konceptualne umetnosti u okviru koje su izlagali: D.
      Huebler, J. Baldessari, B. Flanagan, J. Latham, On Kawara, G. Anselmo, G.
      Trbuljak, B. Dimitrijević, R. Damnjanović-Damnjan, grupa Bosch+Bosch, S.
      LeWitt, D. Buren.
      <br />
      -Jun – jul: Salon Muzeja savremene umetnosti, Beograd. DOKUMENTI O
      POSTOBJEKTNIM POJAVAMA U JUGOSLOVENSKOJ UMETNOSTI 1968–1973.
      <br />
      -Avgust-septembar: The Richard Demarco Gallery, Edinburgh. EDINBURGH ARTS
      ’73. Izložba/performansi osam jugoslovenskih umetnika u okviru
      Međunarodnog festivala umetnosti na kome je M. Abramović izvela prvi
      performans Ritam 10, kao i R. Todosijević (Odluka kao umetnost I sa M.
      Koželj).
      <br />
      -Septembar: Galerija Studentskog kulturnog centra, Beograd. MANIFESTACIJE
      POVODOM VII BITEF-a. Raša Todosijević izveo izložbu/performans Odluka kao
      umetnost II. Održana dokumentarna izložba Informacije 3 o radu galerija
      koje su od sredine šezdesetih godina odigrale pionirsku ulogu u formiranju
      savremenih umetničkih pojava ili su ustanovile novi odnos
      umetnik-galerija.
      <br />
      -Septembar-oktobar: Izlazi prvi broj časopisa MOMENT (Bilten Likovnog
      programa Studentskog kulturnog centra, Beograd; urednik: B. Tomić). U
      prvom dvobroju objavljeni su tekstovi: D. Buren, Umetnost, lažni
      prosvetitelj; J. Kosuth, Umetnički predmet – izolovani događaj;
      informacije o grupi Bosch+Bosch, Ekipi A³, kao i intervju sa J. Beuysom,
      Društvo kao skulptura.
      <br />
      -Oktobar: Galerija Studentskog kulturnog centra, Beograd. OKTOBAR 73.
      Akcije/projekcije/performansi.
      <br />
      -Novembar: Parking Villa Borghese, Rim. CONTEMPORANEA. Međunarodna izložba
      (istorijska panorama 1955-1973) koju je organizovao A. Bonito Oliva. Od
      jugoslovenskih umetnika učestvovali: M. Abramović, B. Dimitrijević i B.
      Poznanović.
      <br />
      <br />
      <Bold>1974.</Bold>
      <br />
      -April: Studentski kulturni centar, Beograd. III APRILSKI SUSRET. Tema
      susreta: Prošireni medij ili nova umetnost.
      <br />
      -Maj-jun: Galerija Studenskog kulturnog centra, Beograd. Izložba 1 & 1 po
      koncepciji R. Todosijevića.
      <br />
      -Jun-jul: Galerija Studenskog kulturnog centra, Beograd. Održana izložba
      SLIKE po koncepciji J. Denegrija na kojoj su izlagali J. Knifer, V.
      Kristl, J. Zanetti, B. Dimitrijević, G. Urkom, R. Damnjanović-Damnjan, R.
      Todosijević.
      <br />
      -Jun-oktobar: Ruma. VERBUMPROGRAM. Ratomir Kulić i Vladimir Mattioni
      otpočeli zajednički rad serijom kućnih izložbi: Pesme, Na putu,
      Sertifikati mentalnog procesa.
      <br />
      -Avgust: Subotica. BOSCH+BOSCH. Prvi broj časopisa WOW.
      <br />
      -Oktobar: Tribina mladih, Novi Sad. TELO UMETNIKA KAO SUBJEKT I OBJEKT
      UMETNOSTI. Prva publikacija o Body artu u Jugoslaviji. Priredio: V.
      Kopicl.
      <br />
      -Oktobar: Galerija suvremene umjetnosti, Zagreb. MARINA ABRAMOVIĆ.
      Samostalna izložba/performans. Prvi put izveden Ritam 2.
      <br />
      -Decembar: Likovni salon Tribine mladih, Novi Sad.
      DAMNJAN–TODOSIJEVIĆ–URKOM. Prva izložba primarnog slikarstva u Jugoslaviji
      prema koncepciji J. Denegrija.
      <br />
      -MARINA ABRAMOVIĆ izvela performans Ritam 4 u Galeria Diagramma, Milano.
      <br />
      -Kunsthalle, Keln. FLASH ART INFORMATION. Međunarodna izložba umetnika
      koji su sarađivali u časopisu Flash Art. Jugoslovenski izlagači: M.
      Abramović, B. Dimitrijević, R. Todosijević, B. Poznanović, N. i S. Dragan,
      G. Trbuljak, Z. Popović…
      <br />
      <br />
      <Bold>1975.</Bold>
      <br />
      -Februar: MARINA ABRAMOVIĆ izvodi performans Ritam O u Studio Morra,
      Napulj.
      <br />
      -Februar-mart: Galerija Studentskog kulturnog centra, Beograd.
      VERBUMPROGRAM. Prva izložba Verbumprograma u Beogradu.
      <br />
      -Mart: Beograd, GRUPA 143. 14. 3. 1975. osnovana Grupa 143. Prvi članovi:
      Biljana Tomić, Miško Šuvaković, Bojana Burić, Stipe Dumić, Nada Seferović,
      Momčilo Rajan, Slobodan Šajin.
      <br />
      -April: Galerija Studentskog kulturnog centra, Beograd. IDEOLOGIJA
      NJUJORKA. Predavanje Jasne Tijardović i Zorana Popovića, kao i
      predstavljanje filmova njujorških autora.
      <br />
      -IV APRILSKI SUSRET. Na IV aprilskom susretu Proširenih medija učestvovali
      su V. Radovanović, J. Čekić, R. Todosijević, Z. Popović, K. Ladik, N.
      Paripović, G. Đorđević, M. Abramović, S. Iveković, D. Maritnis, B.
      Szombathy, M. Šuvaković, Ž. Jerman, M. Stilinović, Endre Tot, A. Altamira,
      Natalia LL, Ugo La Pietra, A. Dias, K. Sieverding, U. Rosenbach, De
      Filippi...
      <br />
      <ul style={{ paddingLeft: "40px", margin: 0, listStyleType: "disc" }}>
        <li>Fluksus filmovi (koncepcija Giancarlo Politi)</li>
        <li>Jack Moore – Evropski i američki umetnici, video-program</li>
        <li>Razgovor Žene u umetnosti.</li>
      </ul>
      -April-maj: Salon Muzeja savremene umetnosti, Beograd. MARINA ABRAMOVIĆ.
      Samostalna izložba – dokumenti performansa.
      <br />
      -Septembar: Salon Muzeja savremene umetnosti, Beograd. MANIFESTACIJE
      POVODOM IX BITEF-a.
      <ul style={{ paddingLeft: "40px", margin: 0, listStyleType: "disc" }}>
        <li> T. Marioni izveo akciju Pravljenje crteža</li>
        <li> B. Dimitrijević, Intervju</li>
        <li> J. Denegri, dokumentarna izložba, Umetnik u prvom licu</li>
        <li> Razgovor Dodir likovne umetnosti i pozorišta.</li>
      </ul>
      -Septembar-oktobar: The Richard Demarco Gallery, Edinburgh. ASPECTS 75.
      CONTEMPORARY YUGOSLAV ART. Izložba u organizaciji Galerije suvremene
      umjetnosti, Zagreb.
      <br />
      -Septembar–novembar: IX BIENNALE DE JEUNES, Pariz. Međunarodna
      manifestacija mladih umetnika na kome su učestvovali jugoslovenski
      umetnici M. Abramović i G. Đorđević.
      <br />
      -Oktobar: ART & LANGUAGE. Michael Corris i Andrew Menard održali
      predavanje o grupi Art & Language iz Njujorka u Muzeju savremene
      umetnosti, Beograd, a potom i seminar u Galeriji Studentskog kulturnog
      centra na kome su učestvovali i Jill Breacstone i Jasna Tijardović.
      Objavljena je publikacija Art & Language u izdanju Muzeja savremene
      umetnosti i Studentskog kulturnog centra.
      <br />
      -Oktobar-novembar: Akademie der bildended Künste, Beč. Održana izložba
      ASPEKTE GEGEN-WARTIGE KUNST AUS JUGOSLAWIEN u organizaciji Galerije
      suvremene umjetnosti, Zagreb.
      <br />
      -The Fox, Njujork, br. 1 – 3. Izdavač: Art&Language, uredništvo: S.
      Charlesworth, M. Corris, P. Heller, J. Kosuth, A. Menard, M. Ramsden. U
      časopisu sarađivali: Jasna Tijardović, Zoran Popović, Goran Đorđević.
      <br />
      -Novembar 1975 – Januar 1976: Održana izložba 12 SAVREMENIH EVROPSKIH
      UMETNIKA u Hillayer Gallery, Masačusets na kojoj su od jugoslovenskih
      umetnika učestvovali R. Todosijević i Z. Popović.
      <br />
      <br />
      <Bold>1976.</Bold>
      <br />
      -Mart-april: Dom omladine, Beograd. RADOVI NA PAPIRU. Izložba po
      koncepciji J. Denegrija.
      <br />
      -April: Održan V APRILSKI SUSRET u Studentskom kulturnom centru u Beogradu
      na temu Umetnik–umetnost–društvo (izložbe/akcije/performansi/projekcije).
      <br />
      -Jun-jul: Održana izložba OTISCI prema koncepciji J. Denegrija, Galerija
      Nova, Zagreb.
      <br />
      -Jun-jul: Prema koncepciji Biljane Tomić održana izložba FOTOGRAFIJA KAO
      UMETNOST, kao druga izložba koju su zajedno realizovali Galerija suvremene
      umjetnosti, Zagreb, Salon Rotovž, Maribor i Muzej savremene umetnosti,
      Beograd. Povodom izložbe organizovana je retrospektiva Antifilm 1963/76
      prema koncepciji Jasne Tijardović.
      <br />
      -Jul-oktobar: LA BIENNALE DI VENEZIA, Venecija. Komesar: R. Putar;
      izlagači: R. Damnjanović, B. Dimitrijević, H. Gvardijančič, B. Jesih, J.
      Knifer, I. Kožarić. U okviru sekcije International events 32–76
      učestvovali M. Abramović/Ulay.
      <br />
      -Septembar: Održana izložba 12 JUGOSLOVENSKIH UMETNIKA I ČASOPIS „TESTERA”
      u Galeriji Srećna nova umetnost, SKC, Beograd. -Oktobar-novembar: Njujork.
      ZORAN POPOVIĆ. Realizacija dokumentarnog filma Borba u Njujorku (Struggle
      in New York).
      <br />
      -Galeri Umwelt, Štutgart. EXPERIMENT BUCHER. Međunarodna izložba
      eksperimentalnih knjiga na kojoj je učestvovao i jugoslovenski autor B.
      Szombathy.
      <br />
      <br />
      <Bold>1977.</Bold>
      <br />
      -Mart: Održana izložba MLADI UMETNICI, ZAGREB u Galeriji Studentskog
      kulturnog centra u Beogradu.
      <br />
      -April. Galerija Srećna nova umetnosti, SKC, Beograd. UMETNOST, IRONIJA
      itd... Izložba radova i dokumenata prema koncepciji R. Todosijevića.
      <br />
      -VI APRILSKI SUSRET. Pored velikog broja jugoslovenskih i inostranih
      učesnika, održane su i sledeće manifestacije:
      <ul style={{ paddingLeft: "40px", margin: 0, listStyleType: "disc" }}>
        <li>
          dokumentarna izložba: Štampani materijali SKC-a, koncepcija: D.
          Vukadinović
        </li>
        <li>
          predavanje: Predstavljanje galerija R. Putar, Galerija suvremene
          umjetnosti, Zagreb; U. Krinzinger, Galerija Krinzinger, Insbruk
        </li>
        <li>
          izložba/publikacija: Istraživanje znakovnog sistema K. Maljeviča prema
          koncepciji: J. Čekić, G. Đorđević, J. Tijardović
        </li>
        <li>
          Izložba: Omoti ploča rock muzike, koncepcija: S. Ilić, M. Rajin.
        </li>
        <li>
          četvorodnevna diskusija na temu: Elektronski mediji u društvenim
          promenama.
        </li>
      </ul>
      -Jun: Galleria Civica, Modena. AVANQUARDIA E SPERIMENTAZIONE (Le piu
      avanzete vicerche artistiche Jugoslave).
      <br />
      -Jun: Gallery Art Net, London. RADICAL ATTITUDES TO THE GALLERY.
      Međunarodna akcija na kojoj su učestvovali i jugoslovenski umetnici,
      između ostalog: G. Đorđević, Z. Popović, N. Baljković, B. Dimitrijević…
      <br />
      -Jun-oktobar: DOCUMENTA 6, Kasel. Velika retrospektiva internacionalne
      umetnosti – performansi, fotografije, film, video, crtež. Jugoslovenski
      učesnici: M. Abramović, B. Dimitrijević, Dado, V. Veličković, Z. Mušić.
      <br />
      -Jul-septembar: Umetnički paviljon „Cvijeta Zuzorić” i Salon Muzeja
      savremene umetnosti, Beograd. V BEOGRADSKI TIRJENALE JUGOSLOVENSKE LIKOVNE
      UMETNOSTI. Sekcije u okviru V Trijenala: Primarno, elementarno,
      procesualno: alternativni modeli aktulene slikarske prakse (T. Brejc);
      Novi Mediji: fotografija, film, video (Matičević); Ka dematerijalizaciji
      umetničkog objekta (M. Susovski).
      <br />
      -Novembar-decembar. Studentski kulturni centar, Beograd. NOVA MUZIKA.
      Koncepcija: M. Savić. Preslušavanje ploča (J. Cage, L. M. Young, Ph.
      Glass, T. Riley, S. Reich).
      <br />
      -INTERNATIONAL PERFORMANCE FESTIVAL, Osterreichischer Kunstverein, Beč.
      Učestovali: M. Savić, Marina/Ulay, R. Todosijević…
      <br />
      -Brezovica. KOMUNA BISTRI POTOK. Božidar Mandić sa porodicom i
      prijateljima osnovao Komunu.
      <br />
      <br />
      <Bold>1978.</Bold>
      <br />
      -Januar: Galerija Studentskog kulturnog centra, Beograd. IZLOŽBA/AKCIJA
      <br />
      -Februar: Galerija Studentskog kulturnog centra, Beograd. PRIMERI
      ANALITIČKIH RADOVA.
      <br />
      -April: Galerija Studentskog kulturnog centra, Beograd. RADOVI NA PAPIRU
      <br />
      -Maj: Galerija Studentskog kulturnog centra, Beograd. PERFORMANCE MEETING.
      Međunarodni susret – nova muzika, novo pozorište, novi ples, telesna
      umetnost, akcije umetnika.
      <br />
      -Proleće: Galerija suvremene umjetnosti, Zagreb. NOVA UMJETNIČKA PRAKSA
      1966-1978. Prva retrospektiva nove umetnosti u Jugoslaviji.
      <br />
      -Jun: 3+4 (a). Izašao prvi broj novoosnovanog časopis studenata istorije
      umetnosti 3+4.
      <br />
      -Jun-avgust: Museum am Ostwall, Dortmund. TENDENZEN IN DE’ JUGOSLAWISCHEN
      KUNST VON HEUTE. Izložbu organizao Muzej savremene umetnosti, Beograd.
      <br />
      <br />
      <Bold>1979.</Bold>
      <br />
      -Mart: Održana izložba fotografija pod nazivom SEKVENCE u Galeriji
      Studentskog kulturnog centra, Beograd.
      <br />
      -April: Galeriji Studentskog kulturnog centra, Beograd. NAŠ ZAJEDNIČKI RAD
      (izložba/razgovori/publikacija)
      <br />
      -Decembar: Galerija podroom, Zagreb. LINIJE (didaktička izložba)
      <br />
      <br />
      <Bold>1980.</Bold>
      <br />
      -Januar: Galerija Srećna nova umetnost, SKC, Beograd. STANO FILKO.
      Dokumentarna izložba i performans Beli prostor u belom prostoru.
      <br />
      -Januar: Galerija Studentskog kulturnog centra, Beograd. PRIMERI-DRUGA
      SKULTPURA 1961–1979.
      <br />
      -Februar: Studentski kulturni centar, Beograd. OPUS 4. Otpočeo aktivnost u
      okviru Muzičkog programa. Članovi: Milimir Drašković, Miša Savić, Vladimir
      Tošić, Lazarov Miodrag Pashu. (Do sada su izdali nekoliko kataloga,
      publikacija, ploča, kaseta nove muzike).
      <br />
      -Jun. Galerija 45, Novi Beograd. SLIKA = SLIKA. Izložba po koncepciji J.
      Denegrija.
      <br />
      -Septembar – oktobar: Galerija Scene, Zemun. RADOVI UMETNIKA – PRIMERI
      NOVE UMETNOSTI (iz zbirke Muzeja savremene umetnosti). Izložba
      organizovana povodom BITEF-a.
      <br />
      <br />
      *Selekcija na osnovu:{" "}
      <Bold>
        Hronološki pregled. 1966 – 1980. (Ljubica Stanivuk, Zoran Gavrić) u:
        Denegri, Ješa, Nova umetnost u Srbiji: 1970-1980: pojedinci, grupe,
        pojave, Muzej savremene umetnosti Beograd, 1983.{" "}
      </Bold>
      <br />
      <br />
    </Wrapper>
  );
};

export default ConceptualArt;
